import { asapScheduler, Observable, Subscription } from 'rxjs';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { observeOn, tap } from 'rxjs/operators';
import { AutoUnsubscribe } from '@app/shared/decorators';
import { BreakpointService } from '@spartacus/storefront';
import { RrsFacetNavigationService } from '@app/custom/features/rrs-product-listing/services/rrs-facet-navigation/rrs-facet-navigation.service';
import { Store } from '@ngrx/store';

@AutoUnsubscribe()
@Component({
  selector: 'rrs-facet-list-button',
  templateUrl: './rrs-facet-list-button.component.html',
  styleUrls: ['./rrs-facet-list-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RrsFacetListButtonComponent {
  @ViewChild('trigger') trigger!: ElementRef<HTMLElement>;
  private subscriptions = new Subscription();

  hasTrigger$: Observable<boolean> = this.facetNavigationService.hasTrigger$;

  constructor(
    protected store: Store,
    protected facetNavigationService: RrsFacetNavigationService,
    protected breakpointService: BreakpointService
  ) {
    const hasTriggerSub = this.breakpointService.breakpoint$
      .pipe(
        observeOn(asapScheduler),
        tap(() => this.hasTrigger())
      )
      .subscribe();
    this.subscriptions.add(hasTriggerSub);
  }

  launch(): void {
    this.facetNavigationService.toggleFacetsDialog(true);
  }

  private hasTrigger(): boolean {
    const isVisible = this.trigger.nativeElement.offsetParent !== null;
    this.facetNavigationService.toggleHasTrigger(isVisible);
    return isVisible;
  }
}
